<template>
    <div class="product-alternatives">
        <ul v-if="alternatives.length < 6" class="list-view-container d-flex flex-wrap">
            <li
                v-for="product in sortedSameBrandProducts"
                :key="product.productId"
                class="alternative-product-tile d-flex flex-column text-center"
                :class="{
                    active: product.productId == currentProduct.productId,
                    disabled: product.stock == 0,
                    twoLine: product.valueAndUnit.hasUnit,
                }"
                @click="selectedProduct = product"
            >
                <div class="d-flex flex-column">
                    <span class="">{{ product.valueAndUnit.value }}</span>
                    <span v-if="product.valueAndUnit.hasUnit" class="currency pt-1">{{
                        product.valueAndUnit.unit
                    }}</span>
                </div>
            </li>
        </ul>
        <UIDropdown
            v-else
            id="value-dropdown"
            v-model="selectedProduct"
            variant="custom"
            class="float-right w-100 mt-1 ml-auto value-dropdown mb-5"
            :items="sortedSameBrandProducts"
        >
            <template #button-content="{ item }">
                <div>
                    <nuxt-resource
                        :src="$product.getImage200(item)"
                        :alt="`Card image of ${$product.getName(item)}`"
                        class="product-img mr-2"
                    />
                    <span>{{ $product.getName(item) }}</span>
                </div>
            </template>

            <template #dropdown-content="{ item }">
                <div>
                    <nuxt-resource
                        :src="$product.getImage200(item)"
                        :alt="`Card image of ${$product.getName(item)}`"
                        class="product-img mr-2"
                    />
                    {{ $product.getName(item) }}
                </div>
            </template>
        </UIDropdown>
    </div>
</template>

<script>
import { UIDropdown } from '@dundle/ui/components';
export default {
    components: {
        UIDropdown,
    },
    props: ['currentProduct', 'alternatives', 'currentLocale'],
    data() {
        return {
            selectedProduct: this.currentProduct,
        };
    },
    computed: {
        sortedSameBrandProducts() {
            const sameBrandProducts = this.alternatives.filter(x => x.brand === this.currentProduct.brand);
            const result = [this.currentProduct, ...sameBrandProducts];
            return result
                .sort((a, b) => a.price - b.price)
                .map(p => ({
                    ...p,
                    valueAndUnit: this.getProductValue(p),
                }));
        },
    },
    watch: {
        selectedProduct() {
            this.$router.push(this.$product.getPath(this.selectedProduct));
        },
    },
    methods: {
        getProductValue(prod) {
            const valueAndUnit =
                prod.unitType === 'value'
                    ? [this.$product.getTextValue(prod)]
                    : this.$product.getTextValue(prod).split(' ');

            return {
                value: valueAndUnit[0],
                unit: valueAndUnit[1],
                hasUnit: valueAndUnit.length > 1,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.product-alternatives {
    .list-view-container {
        padding: 0;
        width: 100%;
        margin: 0 -0.4rem;

        .alternative-product-tile {
            box-shadow: 0px 0px 0px 1px $color-grey-3;
            color: $color-primary;
            border-radius: 3px;
            font-weight: bold;
            font-size: 1.2rem;
            list-style: none;
            margin: 0.4rem;
            white-space: nowrap;
            width: calc((100% - 2.4rem) / 3);
            line-height: 1;
            min-height: 3rem;

            &.twoLine {
                height: 3.9rem;
                span:first-of-type {
                    font-size: 1.7rem;
                }
            }
            div {
                margin: auto 0px;
            }

            .currency {
                font-size: 0.7rem;
                text-transform: uppercase;
            }

            &.disabled {
                color: $color-grey-4;
            }

            &.active {
                background: $color-primary;
                color: $color-text-inverted;
                text-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
                box-shadow: 0px 0px 0px 1px $color-primary;
            }

            &:hover {
                box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
                cursor: pointer;
                text-decoration: none;

                &.disabled {
                    color: $color-grey-4;
                    box-shadow: 0px 0px 0px 1px rgba(204, 204, 204, 1);
                }
                &.active {
                    box-shadow: inset 0 0 4px 0 rgba(116, 70, 70, 0.5), 0px 0px 0px 1px $color-primary;
                    cursor: default;
                    color: white;
                }
            }
        }
    }

    .ui-dropdown {
        .dropdown-item {
            padding: 0.25rem 1rem;
        }

        .product-img {
            height: 1.5rem;
        }

        .active {
            background: $color-primary;
        }
    }
}
</style>
